import { Progress } from 'antd';
import React from 'react';
import { HardDrive } from 'react-feather';
import Typography from '../../../components/typography/Typography';

export const ProductStorage = ({ volumes }) => {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {[...volumes]?.reverse().map((volume: any, index: number) => {
          const capasity =
            (volume.capacity - volume.freeSpace) / volume.capacity;
          if (volume.capacity > 0) {
            return (
              <div
                key={index}
                className={`bg-white dark:bg-slate-800/60 flex items-start gap-4 border border-slate-100 dark:border-gray-700 p-4 rounded-md`}
              >
                <HardDrive
                  className={`${capasity > 0.8 ? 'text-red-200' : 'text-green-200'} self-center`}
                  size={26}
                />
                <div className="flex-1">
                  <Typography tag={'p'} type={'default'}>
                    {volume.name}/{volume.label}
                  </Typography>
                  <Typography tag={'p'} type={'default'}>
                    {Math.round((volume.freeSpace / 1000000000) * 100) / 100}
                    GB van&nbsp;
                    {Math.round((volume.capacity / 1000000000) * 100) / 100}
                    GB beschikbaar
                  </Typography>
                  <Progress
                    percent={Math.round(capasity * 100)}
                    strokeColor={capasity > 0.8 ? '#ef4444' : ''}
                  />
                </div>
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

export default ProductStorage;
